var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"holiday-type",style:(_vm.styleString)},[_vm._t("icon"),_c('p',[_vm._v(_vm._s(_vm.rowData))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }